<template>
    <div class="cabinet-content-wrap">
        <header
            class="cabinet-header add-product__header flex flex-align-center"
        >
            <router-link
                to="/account/products"
                class="cabinet-btn--remove d-none d-md-block"
            ></router-link>
            <a
                href="javascript:void(0)"
                class="cabinet-btn--form-back-header d-md-none"
                @click.prevent="setStep(step - 1)"
            ></a>
            <h1 class="h1 cabinet-title">Новое изделие</h1>
            <router-link
                to="/account/products"
                class="cabinet-btn--remove-header  d-md-none"
            ></router-link>
        </header>

        <form v-if="step === 1" class="product-form step1">
            <div class="product-form__progress"></div>
            <h3 class="h3 product-form__title required">Категория</h3>

            <div
                v-for="cat in categories"
                :key="cat.CategoryID"
                class="cabinet-form-group"
            >
                <label class="custom-radio">
                    <input
                        v-model="product.category"
                        type="radio"
                        name="category"
                        :value="cat.CategoryID"
                    />
                    <span class="custom-radio__checkmark"></span>
                    {{ cat.Name }}
                </label>
            </div>

            <div class="product-form__btn-wrap">
                <button
                    type="button"
                    class="cabinet-btn product-form__btn"
                    :disabled="!product.category"
                    @click="setStep(2)"
                >
                    Продолжить
                </button>
            </div>
        </form>

        <form v-if="step === 2" class="product-form step2">
            <div class="product-form__progress"></div>
            <h3 class="h3 product-form__title required">Вид изделия</h3>

            <div
                v-for="type in typeByCategory"
                :key="type.TypeID"
                class="cabinet-form-group"
            >
                <label class="custom-radio">
                    <input
                        v-model="product.type"
                        type="radio"
                        name="type"
                        :value="type.TypeID"
                    />
                    <span class="custom-radio__checkmark"></span>
                    {{ type.Name }}
                </label>
            </div>

            <div class="product-form__btn-wrap flex">
                <button
                    type="button"
                    class="cabinet-btn--form-back d-none d-md-block"
                    @click="setStep(1)"
                ></button>
                <button
                    type="button"
                    class="cabinet-btn product-form__btn"
                    :disabled="!product.type"
                    @click="setStep(3)"
                >
                    Продолжить
                </button>
            </div>
        </form>

        <form v-if="step === 3" class="product-form step3">
            <div class="product-form__progress"></div>
            <h3 class="h3 product-form__title required">Материал</h3>

            <div
                v-for="material in materials"
                :key="material.MaterialID"
                class="cabinet-form-group"
            >
                <label class="custom-radio">
                    <input
                        v-model="product.material"
                        type="radio"
                        name="category"
                        :value="material.MaterialID"
                    />
                    <span class="custom-radio__checkmark"></span>
                    {{ material.Name }}
                </label>
            </div>

            <div class="product-form__btn-wrap flex">
                <button
                    type="button"
                    class="cabinet-btn--form-back d-none d-md-block"
                    @click="setStep(2)"
                ></button>
                <button
                    type="button"
                    class="cabinet-btn product-form__btn"
                    :disabled="!product.material"
                    @click="setStep(4)"
                >
                    Продолжить
                </button>
            </div>
        </form>

        <form v-if="step === 4" class="product-form step4">
            <div class="product-form__progress"></div>
            <h3 class="h3 product-form__title">Характеристики</h3>

            <div
                class="cabinet-form-group"
                :class="{
                    error: $v.product.brand.$dirty && $v.product.brand.$invalid
                }"
            >
                <label class="cabinet-form-group__label required">Бренд</label>
                <select-picker
                    :current-value="product.brand"
                    :options="brands"
                    key-value="BrandID"
                    key-title="BrandName"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('brand', $event)"
                />
                <div
                    v-if="$v.product.brand.$dirty && $v.product.brand.$invalid"
                    class="error-label"
                >
                    Поле необходимо заполнить
                </div>
            </div>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="code"
                    >Артикул производителя</label
                >
                <input
                    id="code"
                    v-model="product.article"
                    type="text"
                    class="cabinet-form-group__input"
                    :class="{
                        error:
                            $v.product.article.$dirty &&
                            $v.product.article.$invalid
                    }"
                />
                <div
                    v-if="
                        $v.product.article.$dirty && $v.product.article.$invalid
                    "
                    class="error-label"
                >
                    Введите не более 50 символов
                </div>
            </div>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="name"
                    >Название изделия</label
                >
                <input
                    id="name"
                    v-model="product.name"
                    type="text"
                    class="cabinet-form-group__input"
                    :class="{
                        error:
                            $v.product.name.$dirty && $v.product.name.$invalid
                    }"
                />
                <div
                    v-if="$v.product.name.$dirty && $v.product.name.$invalid"
                    class="error-label"
                >
                    Введите не более 500 символов
                </div>
            </div>

            <div class="cabinet-form-group">
                <div
                    class="cabinet-form-group__label-wrap d-flex justify-content-between"
                >
                    <label class="cabinet-form-group__label">Коллекция</label>
                    <span
                        class="cabinet-form-group__label blue pointer"
                        @click="openCreateCollection"
                        >Создать новую</span
                    >
                </div>

                <select-picker
                    :current-value="product.collection"
                    :options="collectionsByBrand"
                    key-value="CollectionID"
                    key-title="Name"
                    empty-option-title="Нет коллекции"
                    :disabled="!product.brand"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('collection', $event)"
                />
            </div>

            <create-collection
                :is-open="isCreateCollectionOpen"
                :brand-id="product.brand"
                @closeModal="isCreateCollectionOpen = false"
                @onCreateCollection="product.collection = $event"
            />

            <div v-if="isGarnitureFieldAvailable" class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="garniture"
                    >Артикул гарнитура</label
                >
                <garniture-autocomplete
                    :key="product.brand"
                    :initial-garniture="product.garniture"
                    :brand-id="product.brand"
                    @garnitureChange="onGarnitureChange"
                />
            </div>

            <div v-if="!isWatchCategory" class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="size"
                    >Доступные размеры</label
                >
                <input
                    id="size"
                    v-model="product.size"
                    type="text"
                    class="cabinet-form-group__input"
                    :class="{
                        error:
                            $v.product.size.$dirty && $v.product.size.$invalid
                    }"
                />
                <div
                    v-if="$v.product.size.$dirty && $v.product.size.$invalid"
                    class="error-label"
                >
                    Введите не более 150 символов
                </div>
            </div>

            <div v-if="finenessByMaterial.length" class="cabinet-form-group">
                <label class="cabinet-form-group__label">Проба</label>
                <select-picker
                    :current-value="product.fineness"
                    :options="finenessByMaterial"
                    key-value="FinenessID"
                    key-title="Value"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('fineness', $event)"
                />
            </div>

            <div v-if="colors.length" class="cabinet-form-group">
                <label class="cabinet-form-group__label">Цвет металла</label>
                <select-picker
                    :current-value="product.color"
                    :options="colors"
                    key-value="ColorID"
                    key-title="Name"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('color', $event)"
                />
            </div>

            <template v-if="isWatchCategory">
                <div v-if="caseShapes.length" class="cabinet-form-group">
                    <label class="cabinet-form-group__label"
                        >Форма корпуса</label
                    >
                    <select-picker
                        :current-value="product.itemWatch.CaseShapeID"
                        :options="caseShapes"
                        key-value="CaseShapeID"
                        key-title="Name"
                        :classes="['select', 'select--product-form']"
                        @onChange="
                            onItemWatchSelectPickerChange('CaseShapeID', $event)
                        "
                    />
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="CaseSize"
                        >Размер корпуса</label
                    >
                    <input
                        id="CaseSize"
                        v-model="product.itemWatch.CaseSize"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.CaseSize.$dirty &&
                                $v.product.itemWatch.CaseSize.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.CaseSize.$dirty &&
                                $v.product.itemWatch.CaseSize.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="box_height"
                        >Высота корпуса</label
                    >

                    <div class="product-form__unit product-form__unit--w50">
                        <input
                            id="box_height"
                            v-model="product.itemWatch.CaseHeight"
                            type="text"
                            class="cabinet-form-group__input product-form__unit-input"
                            :class="{
                                error:
                                    $v.product.itemWatch.CaseHeight.$dirty &&
                                    $v.product.itemWatch.CaseHeight.$invalid
                            }"
                        />
                        <div class="product-form__unit-text">мм</div>
                    </div>
                    <div
                        v-if="
                            $v.product.itemWatch.CaseHeight.$dirty &&
                                $v.product.itemWatch.CaseHeight.$invalid
                        "
                        class="error-label"
                    >
                        Введите число не более 9 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="Mechanism"
                        >Механизм</label
                    >
                    <input
                        id="Mechanism"
                        v-model="product.itemWatch.Mechanism"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.Mechanism.$dirty &&
                                $v.product.itemWatch.Mechanism.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.Mechanism.$dirty &&
                                $v.product.itemWatch.Mechanism.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="MechanismType"
                        >Тип механизма</label
                    >
                    <input
                        id="MechanismType"
                        v-model="product.itemWatch.MechanismType"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.MechanismType.$dirty &&
                                $v.product.itemWatch.MechanismType.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.MechanismType.$dirty &&
                                $v.product.itemWatch.MechanismType.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label
                        class="cabinet-form-group__label"
                        for="MechanismFeatures"
                        >Дополнительные функции</label
                    >
                    <input
                        id="MechanismFeatures"
                        v-model="product.itemWatch.MechanismFeatures"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.MechanismFeatures.$dirty &&
                                $v.product.itemWatch.MechanismFeatures.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.MechanismFeatures.$dirty &&
                                $v.product.itemWatch.MechanismFeatures.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="MechanismInfo"
                        >Номенклатура</label
                    >
                    <input
                        id="MechanismInfo"
                        v-model="product.itemWatch.MechanismInfo"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.MechanismInfo.$dirty &&
                                $v.product.itemWatch.MechanismInfo.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.MechanismInfo.$dirty &&
                                $v.product.itemWatch.MechanismInfo.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 150 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="Features"
                        >Функции</label
                    >
                    <input
                        id="Features"
                        v-model="product.itemWatch.Features"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.Features.$dirty &&
                                $v.product.itemWatch.Features.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.Features.$dirty &&
                                $v.product.itemWatch.Features.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 150 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="BraceletWidth"
                        >Ширина ремешка</label
                    >

                    <div class="product-form__unit product-form__unit--w50">
                        <input
                            id="BraceletWidth"
                            v-model="product.itemWatch.BraceletWidth"
                            type="text"
                            class="cabinet-form-group__input product-form__unit-input"
                            :class="{
                                error:
                                    $v.product.itemWatch.BraceletWidth.$dirty &&
                                    $v.product.itemWatch.BraceletWidth.$invalid
                            }"
                        />
                        <div class="product-form__unit-text">мм</div>
                    </div>
                    <div
                        v-if="
                            $v.product.itemWatch.BraceletWidth.$dirty &&
                                $v.product.itemWatch.BraceletWidth.$invalid
                        "
                        class="error-label"
                    >
                        Введите целое число не более 10 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label
                        class="cabinet-form-group__label"
                        for="BraceletMaterial"
                        >Материал ремешка</label
                    >
                    <input
                        id="BraceletMaterial"
                        v-model="product.itemWatch.BraceletMaterial"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.BraceletMaterial.$dirty &&
                                $v.product.itemWatch.BraceletMaterial.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.BraceletMaterial.$dirty &&
                                $v.product.itemWatch.BraceletMaterial.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="GlassType"
                        >Стекло</label
                    >
                    <input
                        id="GlassType"
                        v-model="product.itemWatch.GlassType"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.GlassType.$dirty &&
                                $v.product.itemWatch.GlassType.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.GlassType.$dirty &&
                                $v.product.itemWatch.GlassType.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 100 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="Battery"
                        >Элемент питания</label
                    >
                    <input
                        id="Battery"
                        v-model="product.itemWatch.Battery"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.Battery.$dirty &&
                                $v.product.itemWatch.Battery.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.Battery.$dirty &&
                                $v.product.itemWatch.Battery.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="DialType"
                        >Вид циферблата</label
                    >
                    <input
                        id="DialType"
                        v-model="product.itemWatch.DialType"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.DialType.$dirty &&
                                $v.product.itemWatch.DialType.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.DialType.$dirty &&
                                $v.product.itemWatch.DialType.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label" for="DialColor"
                        >Цвет циферблата</label
                    >
                    <input
                        id="DialColor"
                        v-model="product.itemWatch.DialColor"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.DialColor.$dirty &&
                                $v.product.itemWatch.DialColor.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.DialColor.$dirty &&
                                $v.product.itemWatch.DialColor.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label
                        class="cabinet-form-group__label"
                        for="WaterResistance"
                        >Водостойкость</label
                    >
                    <input
                        id="WaterResistance"
                        v-model="product.itemWatch.WaterResistance"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.WaterResistance.$dirty &&
                                $v.product.itemWatch.WaterResistance.$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.WaterResistance.$dirty &&
                                $v.product.itemWatch.WaterResistance.$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>

                <div class="cabinet-form-group">
                    <label
                        class="cabinet-form-group__label"
                        for="PreciousMetalWeight"
                        >Средний вес драгметалла</label
                    >
                    <input
                        id="PreciousMetalWeight"
                        v-model="product.itemWatch.PreciousMetalWeight"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                $v.product.itemWatch.PreciousMetalWeight
                                    .$dirty &&
                                $v.product.itemWatch.PreciousMetalWeight
                                    .$invalid
                        }"
                    />
                    <div
                        v-if="
                            $v.product.itemWatch.PreciousMetalWeight.$dirty &&
                                $v.product.itemWatch.PreciousMetalWeight
                                    .$invalid
                        "
                        class="error-label"
                    >
                        Введите не более 50 символов
                    </div>
                </div>
            </template>

            <template v-if="!isWatchCategory">
                <div v-if="technologies.length" class="cabinet-form-group">
                    <label class="cabinet-form-group__label"
                        >Технология изготовления</label
                    >
                    <select-picker
                        :current-value="product.technology"
                        :options="technologies"
                        key-value="TechnologyID"
                        key-title="Name"
                        :classes="['select', 'select--product-form']"
                        @onChange="onSelectPickerChange('technology', $event)"
                    />
                </div>

                <div class="cabinet-form-group">
                    <label class="cabinet-form-group__label">Тип декора</label>
                    <select-picker
                        :current-value="product.decor"
                        :options="decor"
                        key-value="DecorID"
                        key-title="Name"
                        select-width="100%"
                        :is-multiple="true"
                        :show-multi-selected-titles="true"
                        :classes="['select', 'select--product-form']"
                        @onChange="onMultiSelectPickerChange('decor', $event)"
                    />
                </div>

                <div v-if="purposesByType.length" class="cabinet-form-group">
                    <label class="cabinet-form-group__label">Назначение</label>
                    <select-picker
                        :current-value="product.purpose"
                        :options="purposesByType"
                        key-value="PurposeID"
                        key-title="Name"
                        :classes="['select', 'select--product-form']"
                        @onChange="onSelectPickerChange('purpose', $event)"
                    />
                </div>
            </template>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label">Для кого</label>
                <select-picker
                    :current-value="product.gender"
                    :options="genders"
                    key-value="id"
                    key-title="title"
                    :classes="['select', 'select--product-form']"
                    @onChange="onSelectPickerChange('gender', $event)"
                />
            </div>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="price"
                    >Цена</label
                >
                <div
                    class="product-form__price-wrap-group flex flex-justify-sb flex-align-center"
                >
                    <div class="product-form__price-wrap">
                        <input
                            id="price"
                            v-model="product.price"
                            type="number"
                            min="0"
                            class="cabinet-form-group__input product-form__price"
                            :class="{
                                error:
                                    $v.product.price.$dirty &&
                                    $v.product.price.$invalid
                            }"
                        />
                    </div>

                    <select-picker
                        :current-value="product.priceUnit"
                        :options="priceUnitOptions"
                        key-value="id"
                        key-title="title"
                        :classes="['select', 'select--product-price']"
                        :disabled="isWatchCategory"
                        @onChange="onSelectPickerChange('priceUnit', $event)"
                    />
                </div>
                <div
                    v-if="$v.product.price.$dirty && $v.product.price.$invalid"
                    class="error-label"
                >
                    Введите число от 0 до 99999999.99
                </div>
            </div>

            <div v-if="!isWatchCategory" class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="weight"
                    >Вес</label
                >
                <div class="cabinet-form-group--input-wrap">
                    <div class="position-relative w-50">
                        <input
                            id="weight"
                            v-model="product.weight"
                            type="number"
                            min="0"
                            class="cabinet-form-group__input cabinet-form-group__input--icon"
                            :class="{
                                error:
                                    $v.product.weight.$dirty &&
                                    $v.product.weight.$invalid
                            }"
                        />
                        <div class="cabinet-form-group__icon">гр</div>
                    </div>
                </div>

                <div
                    v-if="
                        $v.product.weight.$dirty && $v.product.weight.$invalid
                    "
                    class="error-label"
                >
                    Введите число от 0 до 9999.99
                </div>
            </div>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="SupplierURL"
                    >Ссылка на страницу изделия</label
                >
                <div class="cabinet-form-group--input-wrap">
                    <input
                        id="SupplierURL"
                        v-model="product.supplierurl"
                        type="text"
                        min="0"
                        class="cabinet-form-group__input cabinet-form-group__input--icon"
                    />
                </div>
            </div>

            <div class="cabinet-form-group">
                <label class="cabinet-form-group__label" for="descr"
                    >Описание</label
                >
                <textarea
                    id="descr"
                    v-model="product.descr"
                    class="cabinet-form-group__textarea cabinet-form-group__textarea--resizable"
                    :class="{
                        error:
                            $v.product.descr.$dirty && $v.product.descr.$invalid
                    }"
                ></textarea>

                <div
                    v-if="$v.product.descr.$dirty && $v.product.descr.$invalid"
                    class="error-label"
                >
                    Введите не более 10 000 символов
                </div>
            </div>

            <div class="product-form__btn-wrap flex">
                <button
                    type="button"
                    class="cabinet-btn--form-back d-none d-md-block"
                    @click="setStep(3)"
                ></button>
                <button
                    type="button"
                    class="cabinet-btn product-form__btn"
                    @click="setStep(5)"
                >
                    Продолжить
                </button>
            </div>
        </form>

        <form v-if="step === 5" class="product-form product-form-insert step5">
            <div class="product-form__progress"></div>

            <div class="subtitle1 mb-4">Вставки</div>
            <div class="row mb-4">
                <div class="caption col-12 col-md-7">
                    <div class="cabinet-form-group--input-wrap">
                        Вы можете добавить текстовое описание вставок или
                        описать каждую вставку отдельно при помощи специальной
                        формы ниже. Обращаем ваше внимание, что данные из
                        текстового описания не отображаются в фильтрах в
                        каталоге ритейлера.
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-12 col-md-6">
                    <div
                        class="cabinet-form-group cabinet-form-group--input-wrap"
                    >
                        <label class="cabinet-form-group__label" for="descr"
                            >Текстовое описание вставок</label
                        >
                        <textarea
                            id="descr"
                            v-model="product.iteminsert"
                            class="cabinet-form-group__textarea cabinet-form-group__textarea--resizable mw-100"
                        ></textarea>
                    </div>
                </div>
            </div>

            <div v-if="!product.inserts.length" class="pt-3 pb-3">
                Без вставок
            </div>

            <div
                v-for="(insert, i) in product.inserts"
                :key="i"
                class="product-form-insert__block"
            >
                <div class="d-flex justify-content-between">
                    <h3 class="h3 product-form__title">
                        Вставка # {{ i + 1 }}
                    </h3>
                    <button
                        type="button"
                        class="cabinet-btn-icon cabinet-btn-icon--default cabinet-btn-icon--small cabinet-btn-icon--trash disabled"
                        @click="removeInsert(i)"
                    ></button>
                </div>

                <div class="row">
                    <div class="col-md-4 order-md-1 product-form-insert__col">
                        <div
                            class="cabinet-form-group"
                            :class="{
                                error:
                                    $v.product.inserts.$each.$iter[i].material
                                        .$dirty &&
                                    $v.product.inserts.$each.$iter[i].material
                                        .$invalid
                            }"
                        >
                            <label class="cabinet-form-group__label"
                                >Материал</label
                            >
                            <select-picker
                                :current-value="insert.material"
                                :options="insertMaterials"
                                key-value="MaterialID"
                                key-title="Name"
                                :classes="['select', 'select--product-form']"
                                :search="true"
                                @onChange="
                                    onInsertSelectPickerChange(
                                        i,
                                        'material',
                                        $event
                                    )
                                "
                            />
                            <div
                                v-if="
                                    $v.product.inserts.$each.$iter[i].material
                                        .$dirty &&
                                        $v.product.inserts.$each.$iter[i]
                                            .material.$invalid
                                "
                                class="error-label"
                            >
                                Поле необходимо заполнить
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 order-md-4 product-form-insert__col">
                        <div class="cabinet-form-group">
                            <label class="cabinet-form-group__label"
                                >Цвет</label
                            >
                            <select-picker
                                :current-value="insert.color"
                                :options="insertColors"
                                key-value="ColorID"
                                key-title="Name"
                                :classes="['select', 'select--product-form']"
                                :search="true"
                                @onChange="
                                    onInsertSelectPickerChange(
                                        i,
                                        'color',
                                        $event
                                    )
                                "
                            />
                        </div>
                    </div>

                    <div class="col-md-4 order-md-2 product-form-insert__col">
                        <div
                            class="cabinet-form-group cabinet-form-group--multiplie"
                        >
                            <label class="cabinet-form-group__label"
                                >Огранка | Количество граней</label
                            >
                            <div class="d-flex justify-content-between">
                                <div class="cabinet-form-group--select-wrap">
                                    <select-picker
                                        :current-value="insert.facet"
                                        :options="insertFacets"
                                        key-value="FacetID"
                                        key-title="Name"
                                        :classes="[
                                            'select',
                                            'select--product-form'
                                        ]"
                                        :search="true"
                                        @onChange="
                                            onInsertSelectPickerChange(
                                                i,
                                                'facet',
                                                $event
                                            )
                                        "
                                    />
                                </div>
                                <div
                                    class="cabinet-form-group--input-wrap cabinet-form-group--input-wrap--small"
                                >
                                    <input
                                        id="face_number"
                                        v-model="insert.faceNumber"
                                        type="number"
                                        min="0"
                                        class="cabinet-form-group__input cabinet-form-group__input--icon cabinet-form-group__input--full"
                                        :class="{
                                            error:
                                                $v.product.inserts.$each.$iter[
                                                    i
                                                ].faceNumber.$dirty &&
                                                $v.product.inserts.$each.$iter[
                                                    i
                                                ].faceNumber.$invalid
                                        }"
                                    />

                                    <div
                                        v-if="
                                            $v.product.inserts.$each.$iter[i]
                                                .faceNumber.$dirty &&
                                                $v.product.inserts.$each.$iter[
                                                    i
                                                ].faceNumber.$invalid
                                        "
                                        class="error-label"
                                    >
                                        Введите число от 0 до 500
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 order-md-5 product-form-insert__col">
                        <div class="cabinet-form-group">
                            <label
                                class="cabinet-form-group__label"
                                for="clarity"
                                >Чистота вставки</label
                            >
                            <input
                                id="clarity"
                                v-model="insert.clarity"
                                type="text"
                                class="cabinet-form-group__input"
                                :class="{
                                    error:
                                        $v.product.inserts.$each.$iter[i]
                                            .clarity.$dirty &&
                                        $v.product.inserts.$each.$iter[i]
                                            .clarity.$invalid
                                }"
                            />
                            <div
                                v-if="
                                    $v.product.inserts.$each.$iter[i].clarity
                                        .$dirty &&
                                        $v.product.inserts.$each.$iter[i]
                                            .clarity.$invalid
                                "
                                class="error-label"
                            >
                                Введите не более 5 символов
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 order-md-3 product-form-insert__col">
                        <div class="cabinet-form-group">
                            <label class="cabinet-form-group__label" for="carat"
                                >Общая каратность</label
                            >
                            <div class="cabinet-form-group--input-wrap">
                                <input
                                    id="carat"
                                    v-model="insert.size"
                                    type="number"
                                    min="0"
                                    class="cabinet-form-group__input cabinet-form-group__input--icon"
                                    :class="{
                                        error:
                                            $v.product.inserts.$each.$iter[i]
                                                .size.$dirty &&
                                            $v.product.inserts.$each.$iter[i]
                                                .size.$invalid
                                    }"
                                />
                                <div class="cabinet-form-group__icon">crt</div>
                            </div>
                            <div
                                v-if="
                                    $v.product.inserts.$each.$iter[i].size
                                        .$dirty &&
                                        $v.product.inserts.$each.$iter[i].size
                                            .$invalid
                                "
                                class="error-label"
                            >
                                Введите число от 0 до 99999.999
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 order-md-6 product-form-insert__col">
                        <div class="cabinet-form-group">
                            <label class="cabinet-form-group__label" for="stone"
                                >Количество камней</label
                            >
                            <div class="cabinet-form-group--input-wrap">
                                <input
                                    id="stone"
                                    v-model="insert.quantity"
                                    type="number"
                                    min="0"
                                    class="cabinet-form-group__input cabinet-form-group__input--icon"
                                    :class="{
                                        error:
                                            $v.product.inserts.$each.$iter[i]
                                                .quantity.$dirty &&
                                            $v.product.inserts.$each.$iter[i]
                                                .quantity.$invalid
                                    }"
                                />
                                <div class="cabinet-form-group__icon">шт</div>
                            </div>
                            <div
                                v-if="
                                    $v.product.inserts.$each.$iter[i].quantity
                                        .$dirty &&
                                        $v.product.inserts.$each.$iter[i]
                                            .quantity.$invalid
                                "
                                class="error-label"
                            >
                                Введите число от 0 до 1000
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /product-form-insert__block -->

            <div
                class="cabinet-form-group d-flex flex-column flex-md-row align-items-md-center"
            >
                <button
                    type="button"
                    class="cabinet-btn cabinet-btn--default cabinet-btn--gray cabinet-btn--add cabinet-btn--big"
                    :disabled="product.inserts.length >= 100"
                    @click="addInsert()"
                >
                    Добавить вставку
                </button>
                <span
                    v-if="product.inserts.length >= 100"
                    class="pt-3 pt-md-0 pl-md-3"
                    >Вы добавили максимальное количество вставок.</span
                >
            </div>

            <div class="product-form__btn-wrap flex">
                <button
                    type="button"
                    class="cabinet-btn--form-back d-none d-md-block"
                    @click="setStep(4)"
                ></button>
                <button
                    type="button"
                    class="cabinet-btn product-form__btn"
                    @click="setStep(6)"
                >
                    Продолжить
                </button>
            </div>
        </form>

        <form v-show="step === 6" class="product-form step6">
            <div class="product-form__progress"></div>
            <h3 class="h3 product-form__title required">Изображения</h3>

            <edit-images @onImagesChange="onProductImagesChange($event)" />

            <div
                v-if="$v.product.images.$dirty && $v.product.images.$invalid"
                class="error-label"
            >
                Изображения не выбраны
            </div>

            <div id="productImagesBtn" class="product-form__btn-wrap flex">
                <button
                    type="button"
                    class="cabinet-btn--form-back d-none d-md-block"
                    @click="setStep(5)"
                ></button>
                <button
                    type="button"
                    class="cabinet-btn product-form__btn"
                    @click="setStep(7)"
                >
                    Продолжить
                </button>
            </div>
        </form>

        <form v-if="step === 7" class="product-form step7">
            <div class="product-form__progress"></div>
            <h3 class="h3 product-form__title required">Видимость</h3>

            <product-visibility
                :visibility="product.visibility"
                @onChange="onProductVisibilityChange($event)"
            />

            <div class="product-form__btn-wrap flex">
                <button
                    type="button"
                    class="cabinet-btn--form-back d-none d-md-block"
                    @click="setStep(6)"
                ></button>
                <button
                    type="button"
                    class="cabinet-btn product-form__btn"
                    :class="{ loading: loading }"
                    @click="onCreateProduct"
                >
                    Сохранить изделие
                </button>
            </div>
        </form>

        <!-- {{typeByCategory}} -->
    </div>
</template>

<script>
import SelectPicker from '@/components/Elements/SelectPicker'
import CreateCollection from '@/components/Cabinet/Supplier/Collection/CreateCollection'
import EditImages from '@/components/Cabinet/Supplier/Product/EditImages'
import ProductVisibility from '@/components/Cabinet/Supplier/Product/ProductVisibility'
import GarnitureAutocomplete from '@/components/Cabinet/Supplier/Product/GarnitureAutocomplete.vue'
import jqForm from '@/mixins/jq-form'
import setGarniture from '@/mixins/setGarnitureToProduct'
import { mapState, mapGetters, mapActions } from 'vuex'

import {
    required,
    requiredIf,
    minLength,
    maxLength,
    between,
    integer
} from 'vuelidate/lib/validators'

const validations = {
    product: {
        category: { required },
        type: { required },
        material: { required },
        brand: { required },
        article: {
            maxLength: maxLength(50)
        },
        name: {
            maxLength: maxLength(500)
        },
        size: {
            maxLength: maxLength(150)
        },
        price: {
            required,
            between: between(0, 99999999.99)
        },
        weight: {
            between: between(0, 9999.99)
        },
        descr: {
            maxLength: maxLength(10000)
        },
        itemWatch: {
            CaseShapeID: { integer },
            CaseSize: { maxLength: maxLength(50) },
            CaseHeight: {
                between: between(0, 99999999.99),
                maxLength: maxLength(10)
            },
            Mechanism: { maxLength: maxLength(50) },
            MechanismType: { maxLength: maxLength(50) },
            MechanismFeatures: { maxLength: maxLength(50) },
            MechanismInfo: { maxLength: maxLength(150) },
            Features: { maxLength: maxLength(150) },
            BraceletWidth: { integer, maxLength: maxLength(10) },
            BraceletMaterial: { maxLength: maxLength(50) },
            GlassType: { maxLength: maxLength(100) },
            Battery: { maxLength: maxLength(50) },
            DialType: { maxLength: maxLength(50) },
            DialColor: { maxLength: maxLength(50) },
            WaterResistance: { maxLength: maxLength(50) },
            PreciousMetalWeight: { maxLength: maxLength(50) }
        },
        inserts: {
            $each: {
                material: { required },
                clarity: {
                    maxLength: maxLength(5)
                },
                size: {
                    between: between(0, 99999.999)
                },
                quantity: {
                    integer,
                    between: between(0, 1000)
                },
                faceNumber: {
                    integer,
                    between: between(0, 500)
                }
            }
        },
        images: {
            required,
            minLength: minLength(1),
            $each: {}
        },
        visibility: { required }
    },

    step1: ['product.category'],
    step2: ['product.type'],
    step3: ['product.material'],
    step4: [
        'product.brand',
        'product.article',
        'product.name',
        'product.size',
        'product.price',
        'product.weight',
        'product.descr',
        'product.itemWatch.CaseShapeID',
        'product.itemWatch.CaseSize',
        'product.itemWatch.CaseHeight',
        'product.itemWatch.Mechanism',
        'product.itemWatch.MechanismType',
        'product.itemWatch.MechanismFeatures',
        'product.itemWatch.MechanismInfo',
        'product.itemWatch.Features',
        'product.itemWatch.BraceletWidth',
        'product.itemWatch.BraceletMaterial',
        'product.itemWatch.GlassType',
        'product.itemWatch.Battery',
        'product.itemWatch.DialType',
        'product.itemWatch.DialColor',
        'product.itemWatch.WaterResistance',
        'product.itemWatch.PreciousMetalWeight'
    ],
    step5: ['product.inserts'],
    step6: ['product.images'],
    step7: ['product.visibility']
}

export default {
    name: 'SupplierProductsAdd',
    components: {
        SelectPicker,
        CreateCollection,
        EditImages,
        ProductVisibility,
        GarnitureAutocomplete
    },
    mixins: [jqForm, setGarniture],
    data() {
        return {
            product: {
                category: '',
                type: '',
                material: '',
                collection: '',
                fineness: '',
                color: '',
                technology: '',
                decor: [],
                purpose: '',
                gender: '',
                priceUnit: 1,
                brand: '',
                article: '',
                name: '',
                size: '',
                price: 0,
                weight: '',
                iteminsert: '',
                supplierurl: '',
                descr: '',
                inserts: [],
                images: [],
                visibility: 0,
                garniture: {
                    id: '',
                    set_article: ''
                },
                itemWatch: {
                    CaseShapeID: '',
                    CaseSize: '',
                    CaseHeight: '',
                    Mechanism: '',
                    MechanismType: '',
                    MechanismFeatures: '',
                    MechanismInfo: '',
                    Features: '',
                    BraceletWidth: '',
                    BraceletMaterial: '',
                    GlassType: '',
                    Battery: '',
                    DialType: '',
                    DialColor: '',
                    WaterResistance: '',
                    PreciousMetalWeight: ''
                }
            },
            step: 1,
            isCreateCollectionOpen: false,
            loading: false
        }
    },
    computed: {
        ...mapState('categories', ['categories']),
        ...mapState('types', ['types']),
        ...mapState('caseShapes', ['caseShapes']),
        ...mapGetters('types', ['getTypeByCategory']),
        ...mapState('materials', ['materials']),
        ...mapState('finenesses', ['finenesses']),
        ...mapGetters('finenesses', ['getFinenessByMaterial']),
        ...mapState('colors', ['colors']),
        ...mapState('technologies', ['technologies']),
        ...mapState('decor', ['decor']),
        ...mapState('purposes', ['purposes']),
        ...mapGetters('purposes', ['getPurposesByType']),
        ...mapState('genders', ['genders']),
        ...mapState('insert', [
            'insertMaterials',
            'insertColors',
            'insertFacets'
        ]),
        ...mapState('supplierBrand', ['brands']),
        ...mapState('supplierCollections', ['collections']),
        ...mapGetters('supplierCollections', ['getCollectionsByBrand']),
        ...mapState('other', ['priceUnitOptions']),
        ...mapState('supplierSets', {
            supplierSetsErrors: 'errors'
        }),
        typeByCategory() {
            return this.getTypeByCategory(this.product.category)
        },
        finenessByMaterial() {
            return this.getFinenessByMaterial(this.product.material)
        },
        purposesByType() {
            return this.getPurposesByType(this.product.type)
        },
        collectionsByBrand() {
            return this.getCollectionsByBrand(this.product.brand)
        },
        isGarnitureFieldAvailable() {
            return this.product.category == 1 //"Украшения"
        },
        isWatchCategory() {
            return this.product.category === 5 //Часы
        }
    },
    validations,
    watch: {
        'product.brand': function(newVal, oldVal) {
            this.product.garniture = {
                id: '',
                set_article: ''
            }
        },
        isWatchCategory: function(newVal, oldVal) {
            if (newVal) {
                this.product.type = 36
            } else {
                this.product.type = ''
            }
        },
        'product.type': function() {
            let priceUnit = 1
            for (let i = 0; i < this.typeByCategory.length; i++) {
                if (
                    this.typeByCategory[i].TypeID === this.product.type &&
                    this.typeByCategory[i].PriceUnit
                ) {
                    priceUnit = this.typeByCategory[i].PriceUnit
                }
            }

            return (this.product.priceUnit = priceUnit)
        }
    },
    async mounted() {
        this.$nextTick(() => {
            this.jqForm()
        })

        if (!this.types.length) {
            this.getTypes()
        }
        if (!this.categories.length) {
            this.getCategories({ sort_by: 'Position' })
        }
        if (!this.materials.length) {
            this.getMaterials()
        }
        if (!this.finenesses.length) {
            this.getFineness()
        }
        if (!this.colors.length) {
            this.getColors()
        }
        if (!this.decor.length) {
            this.getDecor()
        }
        if (!this.purposes.length) {
            this.getPurposes()
        }
        if (!this.genders.length) {
            this.getGenders()
        }
        if (!this.insertMaterials.length) {
            this.getInsertMaterials()
        }
        if (!this.insertColors.length) {
            this.getInsertColors()
        }
        if (!this.insertFacets.length) {
            this.getInsertFacets()
        }

        if (!this.collections.length) {
            this.getCollections()
        }
        if (!this.technologies.length) {
            this.getTechnologies()
        }
        if (!this.caseShapes.length) {
            this.getCaseShapes()
        }

        await this.getBrands()
        if (this.brands.length === 1) {
            this.product.brand = this.brands[0].BrandID
        }
    },
    methods: {
        ...mapActions('categories', ['getCategories']),
        ...mapActions('types', ['getTypes']),
        ...mapActions('materials', ['getMaterials']),
        ...mapActions('finenesses', ['getFineness']),
        ...mapActions('colors', ['getColors']),
        ...mapActions('technologies', ['getTechnologies']),
        ...mapActions('decor', ['getDecor']),
        ...mapActions('purposes', ['getPurposes']),
        ...mapActions('genders', ['getGenders']),
        ...mapActions('caseShapes', ['getCaseShapes']),
        ...mapActions('insert', [
            'getInsertMaterials',
            'getInsertColors',
            'getInsertFacets'
        ]),
        ...mapActions('supplierBrand', ['getBrands']),
        ...mapActions('supplierCollections', ['getCollections']),
        ...mapActions('supplierProducts', ['createProduct']),
        ...mapActions('supplierSets', [
            'setItemsToSet',
            'createSet',
            'resetErrors'
        ]),
        setStep(n) {
            if (n >= this.step && !this.isStepValid(this.step)) {
                this.$notify({
                    title: 'Форма заполнена некорректно',
                    type: 'error'
                })
                return
            } else if (n < this.step) {
                switch (n) {
                    case 1:
                        if (!this.isWatchCategory) {
                            this.product.type = ''
                        }
                        break
                    case 3:
                        this.product.fineness = ''
                        break
                    case 2:
                        this.product.purpose = ''
                        break
                }
            }

            this.step = n
        },
        isStepValid(step) {
            const formName = `step${step}`
            this.$v[formName].$touch()

            return !this.$v[formName].$invalid
        },
        onSelectPickerChange(type, val) {
            this.product[type] = parseInt(val)
        },
        onMultiSelectPickerChange(type, val) {
            this.product[type] = val
        },
        onInsertSelectPickerChange(i, type, val) {
            this.product.inserts[i][type] = parseInt(val)
        },
        onItemWatchSelectPickerChange(type, val) {
            this.product.itemWatch[type] = parseInt(val)
        },
        openCreateCollection() {
            if (this.product.brand) {
                this.isCreateCollectionOpen = !this.isCreateCollectionOpen
            } else {
                this.$notify({
                    title: 'Бренд не выбран',
                    type: 'error'
                })
            }
        },
        addInsert() {
            this.product.inserts.push({
                material: '',
                color: '',
                facet: '',
                faceNumber: '',
                clarity: '',
                size: '',
                quantity: ''
            })
        },
        removeInsert(i) {
            this.product.inserts.splice(i, 1)
        },
        onProductImagesChange($event) {
            // console.log($event)
            this.product.images = $event.needSaveImages
        },
        onProductVisibilityChange(val) {
            this.product.visibility = val
        },
        async onCreateProduct() {
            if (this.loading) return

            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.loading = true

                let data = {
                    BrandID: this.product.brand,
                    CategoryID: this.product.category,
                    TypeID: this.product.type,
                    TechnologyID: this.product.technology || undefined,
                    Article: this.product.article,
                    Weight: this.product.weight
                        ? parseFloat(this.product.weight)
                        : undefined,
                    Size: this.product.size,
                    Price: this.product.price,
                    PriceUnit: this.product.priceUnit,
                    Name: this.product.name,
                    ItemInsert: this.product.iteminsert,
                    SupplierURL: decodeURI(this.product.supplierurl),
                    Description: this.product.descr,
                    CollectionID: this.product.collection || undefined,
                    MaterialID: this.product.material,
                    ColorID: this.product.color || undefined,
                    FinenessID: this.product.fineness || undefined,
                    Decor: this.product.decor,
                    Purposes: this.product.purpose
                        ? new Array(1).fill(this.product.purpose)
                        : undefined,
                    AccessLevel: this.product.visibility || undefined, //if 0 not send
                    images: this.product.images.map(item => {
                        return { image: item.url }
                    })
                }

                if (this.isWatchCategory) {
                    let itemWatchFieldsArr = Object.keys(this.product.itemWatch)

                    itemWatchFieldsArr.forEach(field => {
                        let val = this.product.itemWatch[field]
                        data = {
                            ...data,
                            [field]: val
                        }
                    })
                }

                if (this.product.inserts.length) {
                    let inserts = this.product.inserts.map(item => {
                        return {
                            MaterialID: item.material,
                            ColorID: item.color || undefined,
                            FacetID: item.facet || undefined,
                            Clarity: item.clarity,
                            Size: item.size ? parseFloat(item.size) : undefined,
                            Quantity: item.quantity
                                ? parseInt(item.quantity)
                                : undefined,
                            FaceNumber: item.faceNumber
                                ? parseInt(item.faceNumber)
                                : undefined
                        }
                    })

                    data = {
                        ...data,
                        Inserts: inserts
                    }
                }

                if (this.product.gender) {
                    data.Gender = this.product.gender
                }

                try {
                    var resp = await this.createProduct(data)

                    this.$notify({
                        title: 'Продукт успешно добавлен',
                        type: 'success'
                    })

                    this.clearSupplierCatalogFilterDict()

                    this.$router.push('/account/products')
                } catch (e) {
                    this.$notify({
                        title: 'Ошибка',
                        type: 'error'
                    })
                }

                this.loading = false

                if (this.isGarnitureFieldAvailable) {
                    await this.setGarniture(resp.ItemID)
                }
            } else {
                this.$notify({
                    title: 'Форма заполнена некорректно',
                    type: 'error'
                })
            }
        },
        onGarnitureChange(val) {
            this.product.garniture = val
            // console.log('onGarnitureChange')
        }
    }
}
</script>
